module.exports = __webpack_public_path__ + "static/media/visibility-renew.36bb2d0e.svg";